/**
 * Button for clear filters - must be used inside listFilters
 */

app.directive("filterClearButton",function(){
    
   return {
        restrction:"E",
        require: '^^listFilters',
        link:function($scope,element,attrs,$ctrl){
            
            console.log($ctrl.areClear());
            
            
            //checks if are filters are cleared
            $scope.isVisible=function(){
                
                return !$ctrl.areClear();
            
            };
            
            $scope.clearFilters=function(){
                
                //clear filters using listFilters controller
                $ctrl.clear();
                
                //run callback
                $scope.onClick();
            };
            
        },
        scope:{
            
            onClick:"&"
        },
        templateUrl:"/assets/js/angular/components/directives/filters/clearbtn.html",
   } 
    
});



